import toNumber from "lodash/toNumber";

export const formatValue = (value) => {
  if (typeof value === "string") {
    const intValue = toNumber(value); // selected filter ids api returns as strings but options call returns ints
    return isNaN(intValue) ? value : intValue;
  }
  return value;
};
